"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Authorizations = /*#__PURE__*/function () {
  function Authorizations(registry) {
    (0, _classCallCheck2["default"])(this, Authorizations);
    this._api = registry;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Authorizations, [{
    key: "getAllAuthorizations",
    value: function () {
      var _getAllAuthorizations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userId, params) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.OAuthAuthorizationRegistry.List({
                  routeParams: {
                    'user_ids.user_id': userId
                  }
                }, params);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('authorizations', result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllAuthorizations(_x, _x2) {
        return _getAllAuthorizations.apply(this, arguments);
      }

      return getAllAuthorizations;
    }()
  }, {
    key: "deleteAuthorization",
    value: function () {
      var _deleteAuthorization = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(userId, client_id) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.OAuthAuthorizationRegistry.Delete({
                  routeParams: {
                    'user_ids.user_id': userId,
                    'client_ids.client_id': client_id
                  }
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteAuthorization(_x3, _x4) {
        return _deleteAuthorization.apply(this, arguments);
      }

      return deleteAuthorization;
    }()
  }, {
    key: "getAllTokens",
    value: function () {
      var _getAllTokens = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(userId, client_id, params) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.OAuthAuthorizationRegistry.ListTokens({
                  routeParams: {
                    'user_ids.user_id': userId,
                    'client_ids.client_id': client_id
                  }
                }, params);

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadListResponse('tokens', result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllTokens(_x5, _x6, _x7) {
        return _getAllTokens.apply(this, arguments);
      }

      return getAllTokens;
    }()
  }, {
    key: "deleteToken",
    value: function () {
      var _deleteToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userId, client_id, id) {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.OAuthAuthorizationRegistry.DeleteToken({
                  routeParams: {
                    'user_ids.user_id': userId,
                    'client_ids.client_id': client_id,
                    id: id
                  }
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteToken(_x8, _x9, _x10) {
        return _deleteToken.apply(this, arguments);
      }

      return deleteToken;
    }()
  }]);
  return Authorizations;
}();

var _default = Authorizations;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBdXRob3JpemF0aW9ucyIsInJlZ2lzdHJ5IiwiX2FwaSIsImF1dG9CaW5kIiwidXNlcklkIiwicGFyYW1zIiwiT0F1dGhBdXRob3JpemF0aW9uUmVnaXN0cnkiLCJMaXN0Iiwicm91dGVQYXJhbXMiLCJyZXN1bHQiLCJNYXJzaGFsZXIiLCJwYXlsb2FkTGlzdFJlc3BvbnNlIiwiY2xpZW50X2lkIiwiRGVsZXRlIiwicGF5bG9hZFNpbmdsZVJlc3BvbnNlIiwiTGlzdFRva2VucyIsImlkIiwiRGVsZXRlVG9rZW4iXSwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VydmljZS9hdXRob3JpemF0aW9ucy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgwqkgMjAyMiBUaGUgVGhpbmdzIE5ldHdvcmsgRm91bmRhdGlvbiwgVGhlIFRoaW5ncyBJbmR1c3RyaWVzIEIuVi5cbi8vXG4vLyBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuLy8geW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuLy8gWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4vL1xuLy8gICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuLy9cbi8vIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbi8vIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbi8vIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuLy8gU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuLy8gbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG5cbmltcG9ydCBhdXRvQmluZCBmcm9tICdhdXRvLWJpbmQnXG5cbmltcG9ydCBNYXJzaGFsZXIgZnJvbSAnLi4vdXRpbC9tYXJzaGFsZXInXG5cbmNsYXNzIEF1dGhvcml6YXRpb25zIHtcbiAgY29uc3RydWN0b3IocmVnaXN0cnkpIHtcbiAgICB0aGlzLl9hcGkgPSByZWdpc3RyeVxuXG4gICAgYXV0b0JpbmQodGhpcylcbiAgfVxuXG4gIGFzeW5jIGdldEFsbEF1dGhvcml6YXRpb25zKHVzZXJJZCwgcGFyYW1zKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLk9BdXRoQXV0aG9yaXphdGlvblJlZ2lzdHJ5Lkxpc3QoXG4gICAgICB7XG4gICAgICAgIHJvdXRlUGFyYW1zOiB7ICd1c2VyX2lkcy51c2VyX2lkJzogdXNlcklkIH0sXG4gICAgICB9LFxuICAgICAgcGFyYW1zLFxuICAgIClcblxuICAgIHJldHVybiBNYXJzaGFsZXIucGF5bG9hZExpc3RSZXNwb25zZSgnYXV0aG9yaXphdGlvbnMnLCByZXN1bHQpXG4gIH1cblxuICBhc3luYyBkZWxldGVBdXRob3JpemF0aW9uKHVzZXJJZCwgY2xpZW50X2lkKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLk9BdXRoQXV0aG9yaXphdGlvblJlZ2lzdHJ5LkRlbGV0ZSh7XG4gICAgICByb3V0ZVBhcmFtczogeyAndXNlcl9pZHMudXNlcl9pZCc6IHVzZXJJZCwgJ2NsaWVudF9pZHMuY2xpZW50X2lkJzogY2xpZW50X2lkIH0sXG4gICAgfSlcblxuICAgIHJldHVybiBNYXJzaGFsZXIucGF5bG9hZFNpbmdsZVJlc3BvbnNlKHJlc3VsdClcbiAgfVxuXG4gIGFzeW5jIGdldEFsbFRva2Vucyh1c2VySWQsIGNsaWVudF9pZCwgcGFyYW1zKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLk9BdXRoQXV0aG9yaXphdGlvblJlZ2lzdHJ5Lkxpc3RUb2tlbnMoXG4gICAgICB7XG4gICAgICAgIHJvdXRlUGFyYW1zOiB7ICd1c2VyX2lkcy51c2VyX2lkJzogdXNlcklkLCAnY2xpZW50X2lkcy5jbGllbnRfaWQnOiBjbGllbnRfaWQgfSxcbiAgICAgIH0sXG4gICAgICBwYXJhbXMsXG4gICAgKVxuXG4gICAgcmV0dXJuIE1hcnNoYWxlci5wYXlsb2FkTGlzdFJlc3BvbnNlKCd0b2tlbnMnLCByZXN1bHQpXG4gIH1cblxuICBhc3luYyBkZWxldGVUb2tlbih1c2VySWQsIGNsaWVudF9pZCwgaWQpIHtcbiAgICBjb25zdCByZXN1bHQgPSBhd2FpdCB0aGlzLl9hcGkuT0F1dGhBdXRob3JpemF0aW9uUmVnaXN0cnkuRGVsZXRlVG9rZW4oe1xuICAgICAgcm91dGVQYXJhbXM6IHtcbiAgICAgICAgJ3VzZXJfaWRzLnVzZXJfaWQnOiB1c2VySWQsXG4gICAgICAgICdjbGllbnRfaWRzLmNsaWVudF9pZCc6IGNsaWVudF9pZCxcbiAgICAgICAgaWQsXG4gICAgICB9LFxuICAgIH0pXG5cbiAgICByZXR1cm4gTWFyc2hhbGVyLnBheWxvYWRTaW5nbGVSZXNwb25zZShyZXN1bHQpXG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgQXV0aG9yaXphdGlvbnNcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFjQTs7QUFFQTs7QUFoQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7SUFNTUEsYztFQUNKLHdCQUFZQyxRQUFaLEVBQXNCO0lBQUE7SUFDcEIsS0FBS0MsSUFBTCxHQUFZRCxRQUFaO0lBRUEsSUFBQUUsb0JBQUEsRUFBUyxJQUFUO0VBQ0Q7Ozs7O2dIQUVELGlCQUEyQkMsTUFBM0IsRUFBbUNDLE1BQW5DO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQTtnQkFBQSxPQUN1QixLQUFLSCxJQUFMLENBQVVJLDBCQUFWLENBQXFDQyxJQUFyQyxDQUNuQjtrQkFDRUMsV0FBVyxFQUFFO29CQUFFLG9CQUFvQko7a0JBQXRCO2dCQURmLENBRG1CLEVBSW5CQyxNQUptQixDQUR2Qjs7Y0FBQTtnQkFDUUksTUFEUjtnQkFBQSxpQ0FRU0MscUJBQUEsQ0FBVUMsbUJBQVYsQ0FBOEIsZ0JBQTlCLEVBQWdERixNQUFoRCxDQVJUOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7OzsrR0FXQSxrQkFBMEJMLE1BQTFCLEVBQWtDUSxTQUFsQztRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDdUIsS0FBS1YsSUFBTCxDQUFVSSwwQkFBVixDQUFxQ08sTUFBckMsQ0FBNEM7a0JBQy9ETCxXQUFXLEVBQUU7b0JBQUUsb0JBQW9CSixNQUF0QjtvQkFBOEIsd0JBQXdCUTtrQkFBdEQ7Z0JBRGtELENBQTVDLENBRHZCOztjQUFBO2dCQUNRSCxNQURSO2dCQUFBLGtDQUtTQyxxQkFBQSxDQUFVSSxxQkFBVixDQUFnQ0wsTUFBaEMsQ0FMVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7d0dBUUEsa0JBQW1CTCxNQUFuQixFQUEyQlEsU0FBM0IsRUFBc0NQLE1BQXRDO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQTtnQkFBQSxPQUN1QixLQUFLSCxJQUFMLENBQVVJLDBCQUFWLENBQXFDUyxVQUFyQyxDQUNuQjtrQkFDRVAsV0FBVyxFQUFFO29CQUFFLG9CQUFvQkosTUFBdEI7b0JBQThCLHdCQUF3QlE7a0JBQXREO2dCQURmLENBRG1CLEVBSW5CUCxNQUptQixDQUR2Qjs7Y0FBQTtnQkFDUUksTUFEUjtnQkFBQSxrQ0FRU0MscUJBQUEsQ0FBVUMsbUJBQVYsQ0FBOEIsUUFBOUIsRUFBd0NGLE1BQXhDLENBUlQ7O2NBQUE7Y0FBQTtnQkFBQTtZQUFBO1VBQUE7UUFBQTtNQUFBLEM7Ozs7Ozs7Ozs7O3VHQVdBLGtCQUFrQkwsTUFBbEIsRUFBMEJRLFNBQTFCLEVBQXFDSSxFQUFyQztRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUE7Z0JBQUEsT0FDdUIsS0FBS2QsSUFBTCxDQUFVSSwwQkFBVixDQUFxQ1csV0FBckMsQ0FBaUQ7a0JBQ3BFVCxXQUFXLEVBQUU7b0JBQ1gsb0JBQW9CSixNQURUO29CQUVYLHdCQUF3QlEsU0FGYjtvQkFHWEksRUFBRSxFQUFGQTtrQkFIVztnQkFEdUQsQ0FBakQsQ0FEdkI7O2NBQUE7Z0JBQ1FQLE1BRFI7Z0JBQUEsa0NBU1NDLHFCQUFBLENBQVVJLHFCQUFWLENBQWdDTCxNQUFoQyxDQVRUOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7Ozs7ZUFhYVQsYyJ9